<div class="order-manager-wrapper">
    <ispm-order-list [selectedOrder]="selectedOrder"
        [ngStyle]="{width: config?.listPanel?.width, display: config?.listPanel?.hidden == true ? 'none' : 'inherit'}"
        [orders]="orders" [loading]="loading" [config]="config" (onChangeOrder)="handleChangeSelectedOrder($event)"
        (onCreateOrder)="showCreateOrderPopup()" (onDeleteOrder)="deleteOrder($event)" [isEditable]="isEditable"
        [disableAddButton]="disableAddButton" [canDelete]="canDelete">
    </ispm-order-list>

    <ispm-order-content [ngStyle]="{width: config?.contentPanel?.width}" [selectedOrder]="selectedOrder"
        [config]="config" (onFormDataSave)="onSaveOrderContent($event)"
        [orderContentFormConfigs]="selectedOrderDefinition?.formsConfig" [selectedOrderDetails]="selectedOrderDetails"
        [isEditable]="isEditable" [hasUpdatedFields]="hasUpdatedFields"
        [watchPropertyForSaveButton]="watchPropertyForSaveButton">
    </ispm-order-content>


    <gen-dynamic-modal-loader class="pan-cancer-event-modal" [observableName]="ModalLoaderTunnelName">
    </gen-dynamic-modal-loader>
</div>
